module.exports = __webpack_public_path__ + "static/img/7.98875183.png";